export default __webpack_public_path__ + "static/media/quote_sign.41e61966.png";